@if (version.updateAvailable()) {
  <div class="fixed inset-x-0 top-0 z-[9999] bg-slate-950 text-white shadow-xl">
    <div class="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p class="text-sm font-semibold">A new admin portal version is available.</p>
        <p class="text-xs text-slate-300">Refresh to load {{ version.latestVersion() }}.</p>
      </div>
      <button type="button" (click)="version.reload()" class="h-9 rounded-lg bg-white px-4 text-sm font-semibold text-slate-950">
        Refresh now
      </button>
    </div>
  </div>
}
<router-outlet />
